import { render, staticRenderFns } from "./LoaderPage.vue?vue&type=template&id=13a30f1b&scoped=true"
import script from "./LoaderPage.vue?vue&type=script&lang=js"
export * from "./LoaderPage.vue?vue&type=script&lang=js"
import style0 from "./LoaderPage.vue?vue&type=style&index=0&id=13a30f1b&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a30f1b",
  null
  
)

export default component.exports